<template>
    <div class="land-dvor">
        <div class="section-title-mobile" v-if="isMobileChecker">
            <div class="pic-title-bg" :style="'background-image: url(' + salesCard.yard_section_title_img + ')'"></div>
            <!-- <h2>{{salesCard.yard_section_title}}</h2> -->
            <h2 v-html="salesCard.yard_section_title"></h2>
        </div>
        <div class="container">
            <div class="land-dvor-column-container">
                <div class="col-left">
                    <div class="section-title" v-if="!isMobileChecker">
                        <h2>{{salesCard.yard_section_title}}</h2>
                    </div>
                    <div class="desc-html" v-html="salesCard.yard_desc"></div>
                    <div class="desc-icons-list list-six" :class="'desc-icons-' + projectNameG">
                        <ul>
                            <li v-for="(item, index) in salesCard.yard_icon_list" :key="index">
                                <div class="icon-img">
                                    <img :src="item.icon" alt="">
                                </div>
                                <!-- <div class="item-num" v-if="projectNameG == 'duman' && isMobileChecker">{{ index + 1 }}</div> -->
                                <div class="icon-desc">
                                    <p v-html="item.desc"></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-right" v-if="!isMobileChecker">
                    <div class="col-img">
                        <img :src="salesCard.yard_img" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-dvor',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-dvor.scss';
    @import '@/styles/components/sales/respond/land-dvor-respond.scss';
</style>